import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from '../data.service';
import { ActivatedRoute } from "@angular/router";
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-crearencuesta',
  templateUrl: './crearencuesta.component.html',
  styleUrls: ['./crearencuesta.component.css']
})
export class CrearencuestaComponent implements OnInit {
  @Output() creacionFinalizada = new EventEmitter<void>();
  encuestaForm: FormGroup;
  IdEncuesta: string;

  constructor(private fb: FormBuilder, private data: DataService, private route: ActivatedRoute, private messageService: MessageService) {
    this.encuestaForm = this.fb.group({
      Nombre: ['', [Validators.required]],
      Descripcion: ['', [Validators.required]],
      Activa: [true, [Validators.required]],
      AgregarEncuestados: [false, [Validators.required]]
    });
  }

  ngOnInit() {}

  async onSubmit() {
    if (this.encuestaForm.valid) {
      console.log('Formulario enviado:', this.encuestaForm.value);
      //agregar a this.encuestaForm.value los campos FechaCrea, UsuarioCrea, Formulario
      this.encuestaForm.value.FechaCrea = new Date();

      //obtener el formulario de la url
      this.encuestaForm.value.IdFormulario = this.route.snapshot.paramMap.get('id');

      console.log('this.encuestaForm.value:');
      console.log(this.encuestaForm.value);


      this.data.CrearEncuesta(this.encuestaForm.value).subscribe(response => {
        console.log(response);
        this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Encuesta creada exitosamente'});
        this.IdEncuesta=response.id;
        this.creacionFinalizada.emit();
      }, error => {
        console.error('Error al crear la encuesta:', error);
        console.log(error);
        this.messageService.add({severity:'error', summary: 'Error', detail: 'Error al crear la encuesta. Inténtelo nuevamente.'});
      });
    } else {
      console.log('Formulario no válido');
    }
  }

  get controls() {
    return this.encuestaForm.controls;
  }

  cancelarcreacion(){
    console.log('cancelar creación');
    this.creacionFinalizada.emit();
  }
}
